import { SET_REGION } from "../actions";

const initialState = {
  region: localStorage.getItem("region") || "AED", // Default region
};

const regionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REGION:
      localStorage.setItem("region", action.payload);
      localStorage.removeItem("cartDatas");
      localStorage.removeItem("cartIds");
      localStorage.removeItem("cartCount");
      localStorage.removeItem("cartIdKey");

      return {
        ...state,
        region: action.payload,
      };
    default:
      return state;
  }
};

export default regionReducer;
